// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3CPQ3","footer":"ModalInfo_footer__27gtT"};